import React from 'react';

import Card from '../../../components/Card';

interface KOLTitleDescriptionValue {
  title: string;
  description: string;
}

interface KOLTitleDescriptionPresenterProps {
  value?: KOLTitleDescriptionValue;
  onChange?: (value: KOLTitleDescriptionValue) => void;
}

export const KOLTitleDescriptionPresenter: React.FC<KOLTitleDescriptionPresenterProps> = ({ value, onChange }) => {
  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.({ title: e.target.value, description: value?.description ?? '' });
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.({ title: value?.title ?? '', description: e.target.value });
  };

  return (
    <Card className="flex flex-col space-y-8">
      <div className="text-22">Title & Description</div>
      <div className="space-y-6">
        <div className="form-control">
          <label className="label">
            <span className="label-text text-systemGrays02LabelSecondary">
              Title <span className="text-colorsBrandRed01Primary">*</span>
            </span>
          </label>
          <input
            type="text"
            className="input input-bordered w-full font-tt text-systemGrays02LabelSecondary font-semibold"
            value={value?.title || ''}
            onChange={handleTitleChange}
            placeholder="Enter title"
            maxLength={40}
          />
          <div className="text-right text-xs text-systemGrays02LabelSecondary mt-4">{value?.title?.length || 0}/40</div>
        </div>
        <div className="form-control">
          <label className="label">
            <span className="label-text text-systemGrays02LabelSecondary">
              Description <span className="text-colorsBrandRed01Primary">*</span>
            </span>
          </label>
          <textarea
            className="textarea textarea-bordered w-full font-tt text-16 text-systemGrays02LabelSecondary font-semibold"
            value={value?.description || ''}
            onChange={handleDescriptionChange}
            placeholder="Enter description"
            rows={1}
            maxLength={60}
          />
          <div className="text-right text-xs text-systemGrays02LabelSecondary mt-4">{value?.description?.length || 0}/60</div>
        </div>
      </div>
    </Card>
  );
};
